import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCTMun36BmyvtXdmDAnrRtoJZgS4sEdvfc",
    authDomain: "therealchatty101.firebaseapp.com",
    databaseURL: "https://therealchatty101.firebaseio.com",
    projectId: "therealchatty101",
    storageBucket: "therealchatty101.appspot.com",
    messagingSenderId: "598792666114",
    appId: "1:598792666114:web:5abe95822db8b7d0813b1b"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth;
export const db = firebase.database();